import { Component } from "react";
import CommonEnquiryForm from "./CommonEnquiryForm";
import "./CommonEnquiryForm.css";
import enquiry from "../../assets/image/enquiry-icon.png"
export default class CommonEnquiryFormIcon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
  }
  handleClose = () => {
    this.setState({ show: false });
  };

  handleShow = () => {
    this.setState({ show: true });
  };
  render() {
    return (
      <>
        {/* <button className="open-btn-enquiry border-0" onClick={this.handleShow}>
          <img src={enquiry} className="img-fluid" />
        </button> */}
        <button
          className="btn designbtn2 active w-auto new-enquire-btm"
          style={{ marginTop: "6px" }} onClick={this.handleShow}>
          Enquire Now
        </button>
        <CommonEnquiryForm
          showCanvas={this.state.show}
          handleClose={this.handleClose}
        />
      </>
    );
  }
}
